<section class="inicio-page">
  <header class="inicio-header">
    <div>
      <h1>{{title}}</h1>
      <p>{{t?.iniciosubtitulo || 'Módulos disponibles según el perfil del usuario.'}}</p>
    </div>
  </header>

  <section class="inicio-section" aria-label="Módulos operativos">
    <div class="module-grid">
      <a class="module-card module-card--part" [routerLink]="['/parte/dash']" *ngIf="_authSvc.tienePermiso('parte_abm', 'parte_ver', 'parte_crear')" [attr.aria-label]="t?.abrirpartediario || 'Abrir Parte Diario'">
        <span class="module-card__logo">
          <img src="assets/images/complete-logos/Logo-PARTOne-fondo-claro-completo.png" alt="PartOne">
        </span>
        <span class="module-card__content">
          <strong>{{t.partediario}}</strong>
          <span>{{t?.inicioParteDescripcion || 'Registro de actividades en campo, carga móvil y transmisión de partes diarios.'}}</span>
        </span>
        <span class="module-card__action" aria-hidden="true">
          <i class="fa fa-arrow-right"></i>
        </span>
      </a>

      <a class="module-card module-card--doc" [routerLink]="['/controldocumental/dash']" *ngIf="_authSvc.tienePermiso('docu_abm', 'docu_ver', 'docu_crear')" [attr.aria-label]="t?.abrircontroldocumental || 'Abrir Control Documental'">
        <span class="module-card__logo">
          <img src="assets/images/complete-logos/Logo-DOCOne-fondo-claro-completo.png" alt="DocOne">
        </span>
        <span class="module-card__content">
          <strong>{{t.controldocumental}}</strong>
          <span>{{t?.inicioControlDescripcion || 'Documentación de recursos, alertas de vencimiento y habilitación para yacimientos.'}}</span>
        </span>
        <span class="module-card__action" aria-hidden="true">
          <i class="fa fa-arrow-right"></i>
        </span>
      </a>

      <a class="module-card module-card--check" [routerLink]="['/check/dash']" *ngIf="_authSvc.tienePermiso('check_abm', 'check_ver', 'check_crear')" [attr.aria-label]="t?.abrirchecklist || 'Abrir Check List'">
        <span class="module-card__logo">
          <img src="assets/images/complete-logos/Logo-CHECKOne-fondo-claro-completo.png" alt="CheckOne">
        </span>
        <span class="module-card__content">
          <strong>{{t.checklist}}</strong>
          <span>{{t?.inicioCheckDescripcion || 'Chequeos móviles de equipos, instalaciones y modelos configurables.'}}</span>
        </span>
        <span class="module-card__action" aria-hidden="true">
          <i class="fa fa-arrow-right"></i>
        </span>
      </a>

      <a class="module-card module-card--eam" [routerLink]="['/mantenimiento/dash']" *ngIf="_authSvc.tienePermiso('mant_ver_sol', 'mant_crear_sol', 'mant_ver_ot', 'mant_crear_ot', 'mant_vista_plan', 'mant_vista_solic', 'mant_vista_seguim', 'mant_ver_estado', 'mant_ver_medicion', 'mant_crear_medicion', 'mant_ver_talleres', 'mant_abm_talleres')" [attr.aria-label]="t?.abrirmantenimiento || 'Abrir Mantenimiento'">
        <span class="module-card__logo">
          <img src="assets/svgs/eamoneLogo.svg" alt="EamOne">
        </span>
        <span class="module-card__content">
          <strong>{{t.mantenimiento}}</strong>
          <span>{{t?.inicioMantenimientoDescripcion || 'Mantenimiento preventivo y correctivo, solicitudes, órdenes de trabajo e historial de equipos.'}}</span>
        </span>
        <span class="module-card__action" aria-hidden="true">
          <i class="fa fa-arrow-right"></i>
        </span>
      </a>
    </div>
  </section>

  <section class="inicio-section inicio-section--compact" [attr.aria-label]="t?.configuracionadministracion || 'Configuración y administración'">
    <h2>{{t?.configuracion || 'Configuración'}}</h2>
    <div class="admin-grid">
      <a class="admin-card" [routerLink]="['/general/socio-negocio']" *ngIf="_authSvc.tienePermiso('general_abm')" [attr.aria-label]="t?.abrirconfiguraciongeneral || 'Abrir Configuración General'">
        <span class="admin-card__logo">
          <img src="assets/svgs/generalLogoAlt.svg" alt="General">
        </span>
        <span class="admin-card__content">
          <strong>{{t.general}}</strong>
          <span>{{t?.inicioGeneralDescripcion || 'Datos maestros y parámetros generales del sistema.'}}</span>
        </span>
        <span class="admin-card__action" aria-hidden="true">
          <i class="fa fa-arrow-right"></i>
        </span>
      </a>

      <a class="admin-card" [routerLink]="['/backoffice/inquilinos']" *ngIf="_authSvc.tienePermiso('admin_abm')" [attr.aria-label]="t?.abrirbackoffice || 'Abrir Backoffice'">
        <span class="admin-card__logo">
          <img src="assets/svgs/backofficeLogoAlt.svg" alt="Backoffice">
        </span>
        <span class="admin-card__content">
          <strong>{{t.backoffice}}</strong>
          <span>{{t?.inicioBackofficeDescripcion || 'Inquilinos, usuarios, perfiles y seguridad del sistema.'}}</span>
        </span>
        <span class="admin-card__action" aria-hidden="true">
          <i class="fa fa-arrow-right"></i>
        </span>
      </a>
    </div>
  </section>
</section>
